<div class="multi-selector" [class.disabled]="disabled()" [class.open]="isOpen">
  <!-- Trigger/Input Area -->
  <div
    class="selector-trigger"
    [class.focused]="isOpen"
    (click)="onTriggerClick($event)"
  >
    <!-- Selection Summary or Placeholder -->
    <div class="input-area">
      @if (hasSelection) {
        <span class="selection-summary">
          <span class="summary-count">{{ selectedOptions.length }}</span>
          <span class="summary-label">{{ selectedOptions.length === 1 ? 'item' : 'items' }} selected</span>
        </span>
      } @else {
        <span class="placeholder">{{ placeholder() }}</span>
      }
    </div>

    <!-- Actions -->
    <div class="trigger-actions">
      @if (clearable() && hasSelection && !disabled()) {
        <button
          type="button"
          class="clear-btn"
          (click)="clearSelection($event)"
          aria-label="Clear all selections"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      }
      <button
        type="button"
        class="dropdown-toggle"
        (click)="toggleDropdown($event)"
        aria-label="Toggle dropdown"
      >
        <span class="material-symbols-outlined dropdown-icon" [class.rotated]="isOpen">
          expand_more
        </span>
      </button>
    </div>
  </div>

  <!-- Dropdown -->
  @if (isOpen) {
    <div class="dropdown-panel" role="listbox">
      <!-- Search Input -->
      <div class="search-container">
        <span class="material-symbols-outlined search-icon">search</span>
        <input
          #searchInput
          type="text"
          class="search-input"
          [placeholder]="searchPlaceholder()"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          (keydown)="onKeyDown($event)"
          autocomplete="off"
        />
        @if (searchTerm) {
          <button
            type="button"
            class="search-clear"
            (click)="clearSearch($event)"
            aria-label="Clear search"
          >
            <span class="material-symbols-outlined">close</span>
          </button>
        }
      </div>

      <!-- Selected Items -->
      @if (selectedOptions.length > 0 && !searchTerm) {
        <div class="selected-section">
          <div class="selected-header">
            <span class="selected-title">Selected ({{ selectedOptions.length }})</span>
            <button type="button" class="clear-all-btn" (click)="clearSelection($event)">
              Clear all
            </button>
          </div>
          <div class="selected-chips">
            @for (option of selectedOptions; track option.id) {
              <span class="selected-chip">
                <span class="chip-label">{{ option.label }}</span>
                <button
                  type="button"
                  class="chip-remove"
                  (click)="removeOption(option, $event)"
                  [attr.aria-label]="'Remove ' + option.label"
                >
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
          </div>
        </div>
      }

      <!-- Select All Option -->
      @if (showSelectAll() && filteredOptions.length > 0 && !searchTerm) {
        <div class="select-all-option" (click)="toggleSelectAll()">
          <span class="option-checkbox">
            <span class="material-symbols-outlined">
              @if (allSelected) {
                check_box
              } @else if (someSelected) {
                indeterminate_check_box
              } @else {
                check_box_outline_blank
              }
            </span>
          </span>
          <span class="select-all-label">{{ selectAllLabel() }}</span>
          <span class="select-all-count">{{ selectedOptions.length }}/{{ options().length }}</span>
        </div>
      }

      <!-- Options List -->
      <div class="dropdown-options">
        @if (filteredOptions.length === 0) {
          <div class="empty-message">
            <span class="material-symbols-outlined">search_off</span>
            <span>{{ emptyMessage() }}</span>
          </div>
        } @else {
          @for (option of filteredOptions; track option.id; let i = $index) {
            <div
              class="option"
              [class.selected]="isSelected(option)"
              [class.disabled]="option.disabled"
              [class.highlighted]="highlightedIndex === i"
              (click)="selectOption(option)"
              role="option"
              [attr.aria-selected]="isSelected(option)"
              [attr.aria-disabled]="option.disabled"
            >
              <span class="option-checkbox">
                <span class="material-symbols-outlined">
                  {{ isSelected(option) ? 'check_box' : 'check_box_outline_blank' }}
                </span>
              </span>
              @if (showIcon() && option.icon) {
                <span class="material-symbols-outlined option-icon">{{ option.icon }}</span>
              }
              <div class="option-content">
                <span class="option-label">{{ option.label }}</span>
                @if (option.description) {
                  <span class="option-description">{{ option.description }}</span>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>